import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { YoklamaSistemiError } from "../../types/ErrorModals/YoklamaSistemiError";
import { OgrenciDurum, SinifResponseModal, YoklamaRaporuResponseModal, YoklamaSistemiResponseModal } from "../../types/modals";
import { YoklamaSistemiRequestModal } from "../../types/RequestModals/YoklamaSistemiRequestModal";
import { YoklamaKayitRequest } from "../../types/RequestModals/YoklamaKayitRequest";
import { YoklamaRaporuRequestModal } from "../../types/RequestModals/YoklamaRaporuRequestModal";

export const getYoklamaSistemi = async (
  request: YoklamaSistemiRequestModal
): Promise<YoklamaSistemiResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<YoklamaSistemiResponseModal[]>>(
      `${API_URL}/api/YoklamaSistemi/getYoklamaSistemi`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Yoklama listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as YoklamaSistemiError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as YoklamaSistemiError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as YoklamaSistemiError;
    }

    throw {
      message: "Beklenmeyen bir hata oluştu"
    } as YoklamaSistemiError;
  }
};

export const kaydetYoklamaSistemi = async (request: YoklamaKayitRequest): Promise<void> => {
  try {
      const response = await axios.post<ApiResponse<void>>(
          `${API_URL}/api/YoklamaSistemi/kaydetYoklamaSistemi`,
          request
      );

      if (!response.data.success) {
          throw new Error(response.data.message);
      }

  } catch (error) {
      if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError<ApiResponse>;
          const responseData = axiosError.response?.data;

          if (axiosError.response?.status === 404) {
              throw {
                  message: responseData?.message || "Yoklama kaydedilemedi: Kaynak bulunamadı",
                  correlationId: responseData?.correlationId
              } as YoklamaSistemiError;
          }

          if (axiosError.response?.status === 400) {
              throw {
                  message: responseData?.message || "Geçersiz yoklama verisi",
                  errors: responseData?.errors,
                  correlationId: responseData?.correlationId
              } as YoklamaSistemiError;
          }

          if (axiosError.response?.status === 409) {
              throw {
                  message: responseData?.message || "Bu yoklama daha önce kaydedilmiş",
                  correlationId: responseData?.correlationId
              } as YoklamaSistemiError;
          }

          throw {
              message: responseData?.message || "Yoklama kaydedilirken bir hata oluştu",
              correlationId: responseData?.correlationId,
              additionalData: responseData?.additionalData
          } as YoklamaSistemiError;
      }

      throw {
          message: "Beklenmeyen bir hata oluştu"
      } as YoklamaSistemiError;
  }
};

export const getYoklamaRaporu = async (
  request: YoklamaRaporuRequestModal
): Promise<YoklamaRaporuResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<YoklamaRaporuResponseModal[]>>(
      `${API_URL}/api/YoklamaSistemi/getYoklamaRaporu`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Yoklama raporu bulunamadı",
          correlationId: responseData?.correlationId
        } as YoklamaSistemiError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as YoklamaSistemiError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as YoklamaSistemiError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu"
    } as YoklamaSistemiError;
  }
};

export const getSiniflar = async (
  kurumKodu: string,
  sezon: number
): Promise<SinifResponseModal[]> => {
  try {
    const response = await axios.get<ApiResponse<SinifResponseModal[]>>(
      `${API_URL}/api/YoklamaSistemi/getSiniflar?kurumKodu=${kurumKodu}&sezon=${sezon}`
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Sınıf listesi alınamadı",
        correlationId: responseData?.correlationId
      } as YoklamaSistemiError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu"
    } as YoklamaSistemiError;
  }
};

export const getYoklamaDetay = async (
  kurumKodu: string,
  dersId: number,
  tarih: string,
  sezon: number
): Promise<OgrenciDurum[]> => {
  try {
    const response = await axios.get<ApiResponse<OgrenciDurum[]>>(
      `${API_URL}/api/YoklamaSistemi/getYoklamaDetay?kurumKodu=${kurumKodu}&dersId=${dersId}&tarih=${tarih}&sezon=${sezon}`
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Yoklama detayı alınamadı",
        correlationId: responseData?.correlationId
      } as YoklamaSistemiError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu"
    } as YoklamaSistemiError;
  }
};